import Image from 'next/image';
import { projectImages } from 'public/Assets/Images';
import React from 'react';
import { gumletLoader } from '../gumlet';
const thumabHue = [0, 20, 35, 65, 230, 255];
const ThumbnailImage = ({
  itemId
}: any) => {
  return <>
    <Image loader={gumletLoader} src={projectImages.mobileThumbnail(itemId % 6)} fill style={{
      filter: `hue-rotate(${thumabHue[itemId % 6 - 1]}deg)`
    }} alt='programImage' data-sentry-element="Image" data-sentry-source-file="useThumbnailImage.tsx" />
    </>;
};
export default ThumbnailImage;